export enum EResource {
	pdf = 'pdf',
	docx = 'docx',
	pptx = 'pptx',
	xlsx = 'xlsx',
	video = 'video',
	imagen = 'imagen',
	other = 'other',
	link = 'link',
}

export interface ISubject {
	id: number;
	name: string;
	academyId: number;
	departmentId: number;
}

export interface IAcademy {
	id: number;
	name: string;
	departmentId: number;
	subjectCount: number;
}

export interface IDepartment {
	id: number;
	name: string;
	description: string;
	imageUrl: string | null;
	academyCount: number;
	subjectCount: number;
	color: string;
}
